import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.fill";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable no-case-declarations */
import BLUETOOTH_STATUS from 'constants/bluetooth';
import { VIDEO_CLASS_STATE } from 'constants/video';
export var INITIALIZE_PLAYER_ATTRIBUTES = 'classpass/video/INITIALIZE_PLAYER_ATTRIBUTES';
export var RESET_DEVICE = 'classpass/video/RESET_DEVICE';
export var RESET_VIDEO_PLAYER = 'classpass/video/RESET_VIDEO_PLAYER';
export var TOGGLE_CAST = 'classpass/video/TOGGLE_CAST';
export var TOGGLE_CONTROLS = 'classpass/video/TOGGLE_CONTROLS';
export var TOGGLE_INITIAL_PLAY = 'classpass/video/TOGGLE_INITIAL_PLAY';
export var UPDATE_DEVICE = 'classpass/video/UPDATE_DEVICE';
export var UPDATE_PERCENT_PLAYED = 'classpass/video/UPDATE_PERCENT_PLAYED';
export var VIDEO_COMPLETED = 'classpass/video/VIDEO_COMPLETED';
export var SET_VIDEO_MODE = 'classpass/video/SET_VIDEO_MODE';
export var getInitialState = function getInitialState() {
  return {
    bitrate: false,
    casted: false,
    castIntro: false,
    completed: false,
    controlsVisible: true,
    device: {
      bpm: 0,
      calories: 0,
      connection: false,
      classState: VIDEO_CLASS_STATE.SCHEDULED,
      currentZone: {
        name: 'Rest',
        percentage: 0,
        zone: 0
      },
      disconnected: false,
      enabled: false,
      leaderboard: {
        collapsed: false,
        participants: []
      },
      name: '',
      points: 0,
      status: BLUETOOTH_STATUS.UNINITIALIZED,
      targetZone: {
        min_percent: 0,
        max_percent: 0
      }
    },
    featured: [],
    playhead: 0,
    percentPlayed: new Array(100).fill(0),
    started: false
  };
};
export var intializePlayerAttributes = function intializePlayerAttributes(videoId, msa, duration) {
  return {
    type: INITIALIZE_PLAYER_ATTRIBUTES,
    videoId: videoId,
    msa: msa,
    duration: duration
  };
};
export var resetDevice = function resetDevice() {
  return {
    type: RESET_DEVICE
  };
};
export var resetVideoPlayer = function resetVideoPlayer() {
  return {
    type: RESET_VIDEO_PLAYER
  };
};
export var toggleCast = function toggleCast(casted) {
  return {
    type: TOGGLE_CAST,
    casted: casted
  };
};
export var toggleControls = function toggleControls(visible) {
  return {
    type: TOGGLE_CONTROLS,
    visible: visible
  };
};
export var toggleInitialPlay = function toggleInitialPlay() {
  return {
    type: TOGGLE_INITIAL_PLAY
  };
};
export var updateDevice = function updateDevice(device) {
  return {
    type: UPDATE_DEVICE,
    device: device
  };
};
export var updatePercentPlayed = function updatePercentPlayed(currentTime) {
  return {
    type: UPDATE_PERCENT_PLAYED,
    currentTime: currentTime
  };
};
export var videoCompleted = function videoCompleted() {
  return {
    type: VIDEO_COMPLETED
  };
};
export var setVideoMode = function setVideoMode(mode, details) {
  return {
    type: SET_VIDEO_MODE,
    mode: mode,
    details: details
  };
};
export default function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getInitialState();
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case INITIALIZE_PLAYER_ATTRIBUTES:
      return _objectSpread({}, state, {
        videoId: action.videoId,
        msa: action.msa,
        duration: action.duration
      });

    case UPDATE_DEVICE:
      return _objectSpread({}, state, {
        device: _objectSpread({}, state.device, action.device, {
          currentZone: _objectSpread({}, state.device.currentZone, action.device.currentZone),
          leaderboard: _objectSpread({}, state.device.leaderboard, action.device.leaderboard),
          targetZone: _objectSpread({}, state.device.targetZone, action.device.targetZone)
        })
      });

    case UPDATE_PERCENT_PLAYED:
      var segment = Math.round(action.currentTime / state.duration * 100);
      var percentPlayed = state.percentPlayed.slice(0); // TODO: Fix? -- Every click will automatically increment a percent

      percentPlayed[segment] = 1;
      return _objectSpread({}, state, {
        playhead: action.currentTime,
        percentPlayed: percentPlayed
      });

    case TOGGLE_CAST:
      return _objectSpread({}, state, {
        casted: action.casted
      });

    case TOGGLE_CONTROLS:
      return _objectSpread({}, state, {
        controlsVisible: action.visible
      });

    case TOGGLE_INITIAL_PLAY:
      return _objectSpread({}, state, {
        started: true
      });

    case VIDEO_COMPLETED:
      return _objectSpread({}, state, {
        started: false,
        completed: true,
        percentPlayed: new Array(100).fill(0)
      });

    case RESET_VIDEO_PLAYER:
      var reset = getInitialState();
      return _objectSpread({}, reset, {
        device: _objectSpread({}, state.device)
      });

    case RESET_DEVICE:
      var deviceReset = getInitialState().device;
      return _objectSpread({}, state, {
        device: _objectSpread({}, deviceReset)
      });

    case SET_VIDEO_MODE:
      return _objectSpread({}, state, {
        detailMode: action.mode,
        details: action.details
      });

    default:
      return state;
  }
}